module.exports = __webpack_public_path__ + "img/grid-3.aa5a906d.png";